export default __webpack_public_path__ + "static/emotional_story-b67b4959b416b49d70f82ad0ff67c839.png";